import type { ScenarioProjection } from '../domain/types';
import { SourceFields } from './ScenarioEntryInspector';
export function ScenarioCriticalUnknowns({
  data,
  compact = false,
}: {
  readonly data: ScenarioProjection;
  readonly compact?: boolean;
}) {
  const rows = compact ? data.unknownRegister.slice(0, 3) : data.unknownRegister;
  return (
    <section className="scc-unknowns">
      <h2>Critical Unknowns</h2>
      <p>
        {data.unknownRegister.length}{' '}
        条源声明。嵌入字段重复引用同一声明，不代表独立现场事件。此处按源登记顺序呈现，不代表风险排序。
      </p>
      {rows.map((u) => (
        <article key={u.path}>
          <h3>{String(u.value.declarationCode)} · UNKNOWN</h3>
          {compact ? (
            <>
              <p>{String(u.value.reason)}</p>
              <p>{String(u.value.impact)}</p>
            </>
          ) : (
            <SourceFields value={u.value} />
          )}
          {!compact && (
            <details>
              <summary>实际字段位置与具体 Unknown</summary>
              {data.unknowns
                .filter((field) => field.value.declarationCode === u.value.declarationCode)
                .map((field) => (
                  <div key={field.path}>
                    <p>{field.path}</p>
                    <SourceFields value={field.value} />
                  </div>
                ))}
            </details>
          )}
        </article>
      ))}
      <p>需由源声明中相应 Owner 确认。Unknown 不转为默认、安全结论或许可。</p>
    </section>
  );
}
